import { useQueryUserData } from '~/data/user';

import { Icon } from '@vestigas/ui';
import { Spinner } from '@vestigas/ui/molecules';

export const UnauthorizedPage = () => {
  const { isError, isLoading } = useQueryUserData(true);

  const getMessage = () => {
    if (isLoading) {
      return <Spinner title="Berechtigungen werden geladen..." />;
    }

    if (isError) {
      return (
        <>
          <Icon className="mr-2" metaphor="error" />
          Berechtigungen konnten nicht geladen werden.
        </>
      );
    }

    return (
      <>
        <Icon className="mr-2" metaphor="error" />
        Du bist nicht berechtigt, auf diesen Bereich zuzugreifen.
      </>
    );
  };

  return (
    <div className="flex size-full h-screen items-center justify-center">
      {getMessage()}
    </div>
  );
};
